<template>
  <div v-if="group" class="card card-home-feature">
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title tw-leading-snug is-4 is-family-secondary">
            {{ group.name }}
          </p>
          <p
            class="subtitle tw-leading-normal is-size-6 has-text-weight-semibold is-family-other"
          >
            {{ group.address }} <span class="tw-mx-2">&#8226;</span>
            {{ group.members_count }}
            members
          </p>
        </div>
      </div>

      <div class="content">
        <div v-if="group.cover" class="image">
          <img v-lazy="group.cover.url" alt="Group cover" />
        </div>

        <p class="is-size-6">
          {{ about }}
        </p>

        <div v-if="auth.isAuthenticated" class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <router-link
              class="button is-primary"
              :to="{ name: 'groups.show', params: { slug: group.slug } }"
            >
              View their story
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    group: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    }),
    ...mapActions({
      getAuthUser: 'auth/getAuthenticatedUser'
    }),
    strippedAbout() {
      const el = document.createElement('div')
      el.innerHTML = this.group.about
      return el.textContent || el.innerText || ''
    },
    about() {
      const maxChar = 30
      if (this.strippedAbout.split(' ').length > maxChar) {
        return this.strippedAbout
          .split(' ')
          .splice(0, maxChar)
          .join(' ')
          .concat('...')
      }
      return this.strippedAbout
    }
  }
}
</script>
